import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function Solution() {
  return <section className="w-full bg-ink py-20 text-white sm:py-28" data-id="element-172" data-mp="1ejauekalyg7w">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-173" data-mp="10tph9qjhov7s">
        <p className="mb-5 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] text-sunshine" data-id="element-174" data-mp="10rd2fm9130yy">
          <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-175" data-mp="qv9olj4tddw6" />
          Esiste un modo migliore
        </p>
        <h2 className="font-display text-3xl font-black leading-tight sm:text-4xl md:text-5xl" data-id="element-176" data-mp="vumekcqzf12z">
          E se ti supplicassero di{' '}
          <span className="italic text-sunshine" data-id="element-177" data-mp="hvwf4qgowpbg">costruire</span> — invece di
          supplicarti per altro tempo davanti allo schermo?
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-white/70" data-id="element-178" data-mp="2c8mazdqmc8lh">
          MakerLab offre ai tuoi figli oltre 100 progetti pratici di robot che
          vorranno davvero realizzare — costruiti con materiali semplici di
          tutti i giorni e guidati da PDF passo dopo passo facili da seguire.
        </p>
        <div className="mt-10" data-id="element-179" data-mp="2y3xxq2wh9iy">
          <CtaButton data-id="element-180" data-mp="2x2jrcql86x0">Ottieni MakerLab oggi</CtaButton>
        </div>
      </div>
    </section>;
}